import { ComparePage } from "./ComparePage";

export function RxpertiseAlternative() {
  return (
    <ComparePage
      competitor="RxPertise"
      path="/compare/rxpertise-alternative"
      title="RxPertise Alternative for MRR | WeConsult Rx"
      description="Looking for an RxPertise alternative? WeConsult Rx runs the whole monthly consultant-pharmacy workflow — chart ingest, rules + AI review, prescriber/DON e-sign, and invoicing."
      h1="The RxPertise alternative built for modern chart review."
    />
  );
}
